import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import AuthLayout from "./AuthLayout";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Button from "@mui/material/Button";
import { AuthContext } from "../../contextAPI's/authContext";
import BasicAlerts from "../../Components/Boxes/ErrorAndSuccess";
import { FlexBox } from "../../Components/Boxes/index";
import CircularLoader from "../../Components/Icons/circularLoader";
import { color, radius } from "../../Components/Theme";
import { SpanText } from "../../Components/Text";

const AccountList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const AccountCard = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  min-height: 56px;
  box-sizing: border-box;
  text-align: left;
  font: inherit;
  color: ${color("text")};
  background: ${color("surface")};
  border: 1px solid ${color("border-input")};
  border-radius: ${radius("control")}px;
  cursor: pointer;
  &:hover:not(:disabled) {
    border-color: ${color("primary")};
    background: ${color("list")};
  }
  &:focus-visible {
    outline: 3px solid ${color("primary")};
    outline-offset: 2px;
  }
  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
`;

const Avatar = styled.span`
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-weight: 700;
  font-size: 14px;
  color: ${color("primary")};
  background: ${color("primary-light")};
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const initialsOf = (name) =>
  (name ?? "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");

export default function SelectAccount(props) {
    const {
        businessAccounts,
        errorMessage,
        loading,
        onSelect,
    } = props
    console.log(businessAccounts)
    return (
        <AuthLayout title="Select a business account to log into">
            <AccountList>
                {businessAccounts && businessAccounts?.map((businessAccount, index) => {
                    const label = businessAccount.isClientAccess
                        ? (businessAccount.client?.name ?? "Client Access")
                        : businessAccount.businessName;
                    return (
                        <li key={businessAccount.id}>
                            <AccountCard
                                type="button"
                                disabled={!!loading}
                                onClick={() => {
                                    if (!loading)
                                        onSelect(index)
                                }}
                            >
                                <Avatar aria-hidden="true">
                                    {businessAccount.businessLogo
                                        ? <img src={businessAccount.businessLogo} alt="" />
                                        : initialsOf(label)}
                                </Avatar>
                                {businessAccount.isClientAccess && <span>
                                    {businessAccount.client?.name ?? "Client Access"} <SpanText $fontStyle="italic" > ({businessAccount.businessName})</SpanText>
                                </span>}
                                {!businessAccount.isClientAccess && <span>
                                    {businessAccount.businessName}
                                </span>}
                            </AccountCard>
                        </li>
                    )
                })}
            </AccountList>

            {loading && <CircularLoader $size={25} />}
            {errorMessage && (
                <FlexBox $marginTop={2}>
                    <BasicAlerts $type="error">{errorMessage}</BasicAlerts>
                </FlexBox>
            )}
        </AuthLayout>
    )
}
